import React, { Fragment, useEffect, useState } from 'react';
import PopUp from '../container';
import Button from "../../components/button";
import TextField from "../../components/textfield";
import useGlobal from '../../../store';
import "./company_yandex.scss";


const CompanyYandexPopUp = () => {

  const [ Popup, showPopup, hidePopup ] = PopUp();

  const [ globalState, globalActions ] = useGlobal();
  const { company, dummy } = globalState;
  const { companies } = globalActions;

  const {
    
    yandex_metrics_key,
    yandex_metrics_default_key

  } = company;

  const [ code, setCode ] = useState( yandex_metrics_key || "" );

  const tip = ( code === yandex_metrics_key || code === yandex_metrics_default_key ) 

    ? yandex_metrics_key === yandex_metrics_default_key 

      ? ` (сейчас используется общий)` 
      : ` (сейчас используется личный)`

    : ``;

  useEffect(() => { setCode( company.yandex_metrics_key ); }, [ company.yandex_metrics_key ]);

  function clearFields() { setCode(""); }

  function closePopup() {

    hidePopup();
    clearFields();

  }

  function sendData({ setToDefault = false }) {
    
    let popupData = {

      metric_name: `yandex_metrics_key`,
      metric_value: !setToDefault ? code : ""

    }

    companies.editMetric( company.id, popupData, closePopup );

  }

  const setToDefault = () => {

    const ask = `Действительно удалить личный рекламный кабинет, и назначить общий?`;
    window.confirm( ask ) && sendData({ setToDefault: true });
    
  }
  
  const CONTENT = Popup({

    title: 'Яндекс Метрика',
    withoutPadding: true,
    action: sendData,

    content: (

      <div className = "flex">

        <div className = "popup__content popup-yandex">

          <span style = {{ display: 'none' }}>{ dummy }</span>

          <TextField
          
            title = {`Код счётчика${ tip }:`}
            value = { code || "" }
            set   = { setCode }
            
          />

          <p className="popup-yandex__subtitle">Подсказка: в поле нужно вставить <br className="mobile" />только номер (он подчёркнут)</p>
          
          <img src="/images/popup-yandex/sample-desktop.jpg" className="popup-yandex__image desktop" />
          <img src="/images/popup-yandex/sample-mobile.jpg" className="popup-yandex__image mobile" />

          <Button

            text = "Сохранить"
            action = { sendData }

          />

          <Button

            color  = "red"
            action = { setToDefault }
            text   = {(

              <Fragment>
                
                <span className = "desktop">Удалить общий счётчик, и назначить личный</span>
                <span className = "mobile">удалить и назначить общий</span>
                
              </Fragment>
                
            )}
          
          />

        </div>

      </div>

    )

  });

	return [

    CONTENT,
    showPopup,
    hidePopup

  ]

}

export default CompanyYandexPopUp;